<template>
  <section
    class="intelligence-panel"
    :class="{'intelligence-panel--expanded': expanded}"
    role="complementary"
    aria-label="ProApp Intelligence conversation"
  >
    <ProAppIntelligenceHeader
      :expanded="expanded"
      :has-conversation="messages.length > 0"
      :show-settings="messages.length === 0"
      :settings-open="settingsOpen"
      @reset="$emit('reset')"
      @toggle-settings="$emit('toggle-settings')"
      @toggle-expand="$emit('toggle-expand')"
      @close="$emit('close')"
    />
    <ProAppIntelligenceSettings
      v-if="settingsOpen"
      :settings="settings"
      @change="$emit('change-settings', $event)"
      @restore-defaults="$emit('restore-settings')"
    />
    <ProAppIntelligenceMessageList
      v-else
      :messages="messages"
      :thinking="thinking"
      :suggestions="suggestions"
      :introduction="introduction"
      @send="$emit('send', $event)"
    />
    <ProAppIntelligenceInput
      v-if="!settingsOpen"
      :disabled="responding"
      :reset-key="resetKey"
      @send="$emit('send', $event)"
    />
  </section>
</template>

<script>
import ProAppIntelligenceHeader from './ProAppIntelligenceHeader'
import ProAppIntelligenceInput from './ProAppIntelligenceInput'
import ProAppIntelligenceMessageList from './ProAppIntelligenceMessageList'
import ProAppIntelligenceSettings from './ProAppIntelligenceSettings'

export default {
  name: 'ProAppIntelligencePanel',
  components: {
    ProAppIntelligenceHeader,
    ProAppIntelligenceInput,
    ProAppIntelligenceMessageList,
    ProAppIntelligenceSettings,
  },
  props: {
    expanded: Boolean,
    thinking: Boolean,
    responding: Boolean,
    introduction: String,
    settingsOpen: Boolean,
    settings: {
      type: Object,
      required: true,
    },
    messages: {
      type: Array,
      default: () => [],
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    resetKey: Number,
  },
}
</script>

<style lang="scss" scoped>
.intelligence-panel {
  position: fixed;
  right: 10px;
  bottom: 92px;
  width: 410px;
  height: 600px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 112px);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  border-radius: 10px;
  background: white;
  box-shadow: 0 18px 36px rgba(39, 127, 175, 0.2), 0 4px 8px rgba(44, 44, 44, 0.12);
  transition: width 0.25s ease, height 0.25s ease;

  &--expanded {
    width: 780px;
    height: 82vh;
  }
}

@media screen and (min-width: 600px) and (max-width: 999px) {
  .intelligence-panel {
    right: 10px;
    bottom: 16px;
    width: 460px;
    max-width: calc(100vw - 32px);
    height: calc(100vh - 92px);
    max-height: none;
  }
}

@media screen and (max-width: 599px) {
  .intelligence-panel,
  .intelligence-panel--expanded {
    top: 60px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    max-width: none;
    max-height: none;
    border-radius: 0;
    box-shadow: none;
  }
}
</style>
